// Homepage deal / welcome popup — edit this one object to change the offer, the
// copy, or turn it off entirely. Shows once per browser session.
import { DAILY_IMAGES } from "./images";

export const PROMO = {
  enabled: true,
  emoji: "🍱",
  image: DAILY_IMAGES["chicken-biryani"],
  headlineEn: "Today's fresh trays are ready!",
  headlineAr: "صواني اليوم الطازجة جاهزة!",
  bodyEn:
    "Biryani, karahi, nihari & more — cooked fresh twice a day. Order ⚡ fast items and get them in about half the time.",
  bodyAr:
    "برياني، كراهي، نيهاري وأكثر — تُطهى طازجة مرتين يومياً. اطلب أصناف ⚡ السريع واستلمها في نصف الوقت تقريباً.",
  ctaEn: "See today's menu",
  ctaAr: "شاهد قائمة اليوم",
};
